class KCVS.Views.ProcurementPlanItemFormView extends Backbone.View
  events:
    "change input.money" : "calculateTotalAgreementPrice"

  calculateTotalAgreementPrice: ->
    values = _.map $('input.money:not(.disabled)'), (input) ->
      $(input).val()
    total_value = _.reduce values, @accumulateMoney, 0
    $('input.money.disabled').val(parseFloat(total_value).toFixed(2).replace(/[.]/g, ","))

  accumulateMoney: (total, value) ->
    parsed_value = value.replace(/[.]/g, "").replace(/[,]/g, ".")
    total + parseFloat(parsed_value)

